import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ResponsiveService } from 'src/app/services/responsive/responsive.service';
import { BaseComponent } from '../../components/base-component';
import { ProductCategoryItem } from './components/product-categories-item/product-categories-item.component';

@Component({
  selector: 'app-product-categories',
  templateUrl: './product-categories.component.html',
  styleUrls: ['./product-categories.component.scss']
})
export class ProductCategoriesComponent extends BaseComponent implements OnInit {
  constructor(public override responsive: ResponsiveService, public override transloco: TranslocoService) {
    super(responsive, transloco);
  }
  
  @Input()
  addToAnimateClass = false;

  items: ProductCategoryItem[];

  ngOnInit(): void {
    this.transloco.selectTranslateObject(
      'shared.product_categories.items'
    ).subscribe(result => {
      this.items = result;
    });
  }
}
